<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易对设置</el-breadcrumb-item>

    </el-breadcrumb>
    <!-- <el-select v-model="value1" multiple placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select> -->

    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-trade-pair @refresh="refreshList"></create-trade-pair>
        <!-- <hot-pair-config></hot-pair-config> -->
        <el-input placeholder="请输入交易对" clearable v-model="pair">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select :value="state" @change="changeState($event)" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <el-tabs v-model="area" @tab-click="handleAreaChange" type="card">
        <el-tab-pane
          v-for="item in tradeAreaCopy"
          :label="item"
          :name="item"
          :key="item"
        ></el-tab-pane>
      </el-tabs>
      <trade-pair-list @refresh="refreshList" :area="area" :state="state"></trade-pair-list>
      <!-- <trade-pair-list @refresh="refreshList" :area="area"></trade-pair-list> -->
    </el-card>
  </div>
</template>

<script>
import './store';
import TradePairList from './components/list';
import { mapActions, mapState } from 'vuex';
import { PAGINATION } from './constants';
import { Log } from '@icon-park/vue';

export default {
  name: 'TradePairSetting',
  components: {
    TradePairList
  },
  data() {
    return {
      pair: '',
      area: 'USDT',
      state:'',
      tradeAreaCopy:['USDT','ETH'],
      options: [{
          value: 0,
          label: '待上市'
        }, {
          value: 1,
          label: '交易中'
        }, {
          value: 2,
          label: '已下架'
        }, ],
        value1: [],
    };
  },
  computed: {
    ...mapState('tradePairSetting', ['pagination', 'tradeArea'])
  },
  methods: {
    ...mapActions('tradePairSetting', ['list', 'listAllCoin', 'getTradeArea', 'getAllSymbol']),
    refreshList(data = {}) {
      this.getAllSymbol({
        symbol:this.pair,
        buyCoin: this.area,
        ...this.pagination,
        ...data,
        state:this.state,
      });
    },
    changeState(e){
      this.state=e
      this.getAllSymbol({
        symbol: this.pair,
        buyCoin: this.area,
        state:this.state,
        ...this.pagination,
        page: 1
      });
    },
    handleSearch() {
      this.getAllSymbol({
        symbol: this.pair,
        buyCoin: this.area,
        state:this.state,
        ...this.pagination,
        page: 1
      });
    },
    handleAreaChange(tab) {
      this.pair = '';
      this.area = tab.name;
      this.getAllSymbol({
        symbol: this.pair,
        buyCoin: this.area,
        state:this.state,
        ...this.pagination,
        page: 1
      });
    }
  },
  created() {
    this.pair = '';
    // this.listAllCoin();
    // this.getTradeArea().then(() => {
    //   this.area = this.tradeArea[0];
    //   this.list({
    //     area: this.area,
    //     ...PAGINATION
    //   });
    // });
    this.getAllSymbol({page:1,size:10,symbol:this.pair,buyCoin:'USDT',state:this.state})
  },
  mounted () {
   
  }
  
};
</script>

<style lang="less" scoped></style>
